import { Star } from "lucide-react";

export const Stars = ({ value, size = 16, onChange, testid }) => (
  <div className="flex gap-1" data-testid={testid} role={onChange ? "radiogroup" : undefined}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star size={size} className={n <= value ? "fill-[#D4AF37] text-[#D4AF37]" : "text-slate-600"} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star`} data-testid={`${testid}-${n}`}
          className="transition-transform hover:scale-110">{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
